import React from 'react';
import './Badge.css'

class Badge extends React.Component {

  render() {
    return (
      <span className="badge badge-sm badge-o-primary ml-1">{this.props.children}</span>
    )
  }
}

export default Badge;



// WEBPACK FOOTER //
// ./src/components/common/badge/Badge.js